import React from "react";
import { withRouter, Redirect } from "react-router-dom";

//Utils
import { mapPageNav } from "../../../Utils/Utils";

//Hero Images

const Hero = (props) => {
  const { pathname } = props.location;

  const links = [
    {
      title: "Styles",
      destination: `/styles/style`,
    },
    {
      title: "Variations",
      destination: `/styles/variations`,
    },
  ];

  return (
    <div className="row justify-content-center panel-hero">
      {pathname === "/services" ? <Redirect to="/services/landscapes" /> : null}
      <div className="col-12">
        <div className="row justify-content-center hero-unit">
          <div className="col-xl-11">
            <div className="row">
              <div className="hero-cta">
                <h2>
                  Our Pavingstones are more durable and easier to maintain than
                  standard concrete
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-11 col-xl-10">
        <div className="row page-navigation">{mapPageNav(links, pathname)}</div>
      </div>
    </div>
  );
};

export default withRouter(Hero);
